<template>
	<div class="full-chat-left">
		<div class="os-tabs-w">
			<ul class="nav nav-tabs upper centered">
				<li class="nav-item">
					<a class="nav-link active" data-toggle="tab" href="#tab_overview"><i class="os-icon os-icon-mail-14"></i><span>Chats</span></a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_sales"><i class="os-icon os-icon-ui-93"></i><span>Contacts</span></a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_sales"><i class="os-icon os-icon-ui-02"></i><span>Favorites</span></a>
				</li>
			</ul>
		</div>
		<div class="chat-search">
			<div class="element-search">
				<input placeholder="Search users by name..." type="text">
			</div>
		</div>
		<div class="user-list" :class="(convs) ? '' : 'blurred'" v-if="convs">

			<div v-for="c in convs" :key="c.id">
				<router-link class="waves-effect" :to="{ name: 'conversation', params: {id: c.tid} }" active-class="active"  exact>
					<div class="user-w"  v-if="convs" :class="(c.tid == $route.params.id) ? 'activeC' : ''">
						<div class="avatar with-status status-green">
							<ProfilePic :w="40" :h="40" :c="'#00000'" v-if="c.usernames"/>
						</div>
						<div class="user-info" :class="(c.unread > 0) ? 'isbold' : ''">
							<div class="user-date" v-if="c.lastMessageDate">
								{{  c.lastMessageDate | moment('D MMM ddd', session.timezone) |slimiter(10) }}
							</div>
							<div class="user-name" v-if="c.userFullName.length > 1">
								{{ getParticipants(c.participant) }}
							</div>
							<div class="user-name" v-else-if="c.username">
								{{ c.username }}
							</div>
							<div class="last-message">

								{{ c.subject }}
								<div class="unread-count float-right" v-if="c.unread > 0">
									{{  c.unread | tnPlus }}
								</div>
							</div>

						</div>
					</div>
				</router-link>
			</div>
		</div>

		<div class="user-list blurred5" v-show="convsLoader"><div class="user-w"><div class="avatar with-status status-green"><img alt="" src="static/assets/img/avatar1.jpg"></div><div class="user-info"><div class="user-date">12 min</div><div class="user-name">John Mayers</div><div class="last-message">What is going on, are we...</div></div></div><div class="user-w"><div class="avatar with-status status-green"><img alt="" src="static/assets/img/avatar2.jpg"></div><div class="user-info"><div class="user-date">2 hours</div><div class="user-name">Bill Railey</div><div class="last-message">Yes, I've sent you details...</div></div></div><div class="user-w"><div class="avatar with-status status-green"><img alt="" src="static/assets/img/avatar3.jpg"></div><div class="user-info"><div class="user-date">24 min</div><div class="user-name">Simon Backs</div><div class="last-message">What is going on, are we...</div></div></div><div class="user-w"><div class="avatar with-status status-green"><img alt="" src="static/assets/img/avatar1.jpg"></div><div class="user-info"><div class="user-date">7 min</div><div class="user-name">Kelley Brooks</div><div class="last-message">Can you send me this...</div></div></div><div class="user-w"><div class="avatar with-status status-green"><img alt="" src="static/assets/img/avatar7.jpg"></div><div class="user-info"><div class="user-date">4 hours</div><div class="user-name">Vinie Jones</div><div class="last-message">What is going on, are we...</div></div></div><div class="user-w"><div class="avatar with-status status-green"><img alt="" src="static/assets/img/avatar1.jpg"></div><div class="user-info"><div class="user-date">2 days</div><div class="user-name">Brad Pitt</div><div class="last-message">They have submitted users...</div></div></div></div>

	</div>
</template>

<script>
    import ProfilePic from '@/components/user/ProfilePic'

    export default {
        components: { ProfilePic },
        name: 'Conversations',
        data () {
            return {
                session: this.$root.session,
                convsLoader: true,
                convs: false,
	            selectedConv: this.$route.params.id
            }
        },
	    mounted () {
            this.fetchConversations()
	    },
        watch: {
            '$route.params.id': function (cid) {
                this.fetchConversations(cid)
            }
        },
	    methods: {
            fetchConversations (cid = 0) {
                this.convsLoader = (cid) ? false : true;
                this.$http.get(api+'api/v1/message/conversation',
	                {params: cid}
                ).then(response => {
                    if(cid > 0) {
                        this.convs[cid] = response.body.result.conversations[cid];
                        this.convsLoader = false;
                    }else {
                        // get body data
                        this.convs = response.body.result.conversations;

                        this.$emit('conversations', response.body.result.conversations);
                        this.convsLoader = false;
                    }
                }, response => {
                    // error callback
	                switch(response.status) {
		                case 404:
		                    this.convs = 404;
	                    break;
	                }
                })
            },
            getParticipants (Participants) {
                var pname = new Array;

                Participants.forEach(function(p) {
                    if(p.id != session.uid) {
                        pname.push(p.userFullName);
                    }

                });

                return pname.join(',');
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.full-chat-w .full-chat-left .user-list .user-w .avatar {
		margin-right: 0px;
	}
	.full-chat-w .full-chat-left .user-list .user-w .unread-count {
		float: right;
		padding: 2px 7px;
		background-color: #ff4f4f;
		border-radius: 12px;
		font-size: 0.72rem;
		color: rgba(0, 0, 0, 0.3);
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
		color: #fff;
		text-align: center;
		width: 25px
	}

	.full-chat-w .full-chat-left .user-list .user-w {
		padding: 10px 10px;
	}
	.isbold {
		font-weight: bold !important;
		color: #000;
	}

	.activeC {
		background-color: #ffe3e3;
	}

	.full-chat-w .full-chat-left .user-list .user-w .user-date {
		float: right;
		padding: 2px 7px;
		background-color: #fff;
		border-radius: 12px;
		font-size: 0.72rem;
		color: rgba(0, 0, 0, 0.3);
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
	}
</style>



// WEBPACK FOOTER //
// src/components/message/Conversations.vue